import type { FC } from 'react'

const AppFooter: FC = () => (
  <footer className="bg-green-900 w-full flex justify-center">
    <div className="max-w-[1320px] my-6 mx-4 lg:m-16">
      <p
        data-nosnippet
        data-testid="copyright"
        className="font-mono text-[14px] leading-[20px] font-normal text-green-300"
      >
        © {new Date().getFullYear()} Mission Lane LLC. All rights reserved. NMLS #1857501.
        <br />
        <br />
        Mission Lane LLC does business in Arizona under the trade name Mission Lane Card Services
        LLC. All trademarks not belonging to Mission Lane are the property of their respective
        owners.
        <br />
        <br />
        The Mission Lane Visa<sup>®</sup> Credit Card is issued by Transportation Alliance Bank,
        Inc. dba TAB Bank, Member FDIC, or WebBank, pursuant to a license from Visa U.S.A. Inc.
        Mission Lane LLC is the servicer for your Account, but is not a bank. The bank issuing your
        card will be identified on the back of your Visa Card and in your Cardholder Agreement,
        which governs your use of the Account.
        <br />
        <br />
        Paying bills on time, keeping your balance low, and having a long credit history, among
        other things, can help your chances of improving your credit.
        <br />
        <br />
        THIS IS A LOAN SOLICITATION ONLY. MISSION LANE LLC IS NOT THE LENDER. INFORMATION RECEIVED
        WILL BE SHARED WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR LOAN INQUIRY. THE
        LENDER MAY NOT BE SUBJECT TO ALL VERMONT LENDING LAWS. THE LENDER IS SUBJECT TO FEDERAL
        LENDING LAWS.
      </p>
    </div>
  </footer>
)

export default AppFooter
